<script lang='ts'>
    import {SelectSlider} from "@/Common";
    import { maxWeeklyHoursBounds } from "@/Common/constants";
    import {ProgramAchievabilityStatusIcon} from "..";
    import type { AchievabilityStatus } from "@/Program/modules/ProgramAchievability";

    export let hours: Number
    export let disabled = false
    export let onInput: () => void = () => {}
    export let hoursAchievability: AchievabilityStatus = null

</script>

<div class="grid items-center">
    <SelectSlider class="col-span-3" {...maxWeeklyHoursBounds} {disabled}
        bind:value={hours}
        on:input={onInput}
    /> 
    <span class="row-start-2 text-sm text-slate-400 self-start justify-self-start ml-1">{maxWeeklyHoursBounds.min}h</span>
    <span class="inline-flex items-baseline gap-2 justify-self-center text-center">
        <span>{hours}<span class="text-sm text-slate-500">hrs</span></span>
        {#if hoursAchievability}
            <span><ProgramAchievabilityStatusIcon status={hoursAchievability}/></span>
        {/if}
    </span>
    <span class="text-sm text-slate-400 self-start justify-self-end mr-1">{maxWeeklyHoursBounds.max}h</span>
</div>